import BaseModel from '../core/BaseModel'
import UserModel from '@/models/UserModel'
export default class SetUpTermModel extends BaseModel {

    constructor() {
        super({
                name: "set_up_term",
                tableName: 'set_up_term',
                label: "Set Up Term",
                display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Term name',
                    class: 'left',
                    filter: {type: 'input', match: 'contains'},
                    width : 15,
                },
                
                // vehicle category
                vehicle_category_id: {
                    name:'vehicle_category_id',
                    label:'Vehicle category',
                    type: "Selection",
                    custom: 'SelectionText',
                    filter: {type: 'input', match: 'contains'},
                    class: 'left',
                   
                },
                duration: {
                    name: 'duration',
                    type: "Number",
                    label: 'Duration',
                    class: 'left',
                },
                unit_duration : {
                    name: 'unit_duration',
                    type: "Number",
                    display : false,
                    class: 'left',
                },
                price_per_unit_before : {
                    name: 'price_per_unit_before',
                    type: "Number",
                    label: 'Price before discount',
                    class: 'left',
                    width : 10,
                },
                price_per_unit : {
                    name: 'price_per_unit',
                    type: "Number",
                    label: 'Price after discount',
                    class: 'left',
                    width : 10,
                },
                bond_fee_key: {
                    name: "bond_fee_key",
                    label: "Bond fee",
                    type: "Computed",
                    computed: (data) => {
                        data.bond_fee_key = data.bond_fee_key_text;
                    },
                },
                booking_fee : {
                    name: 'booking_fee',
                    type: "Number",
                    label: 'Booking fee',
                    class: 'left',
                    width : 10,
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'true', label: 'Yes', style: 'color:  #000000;'},
                        {value: 'false', label: 'No',style: 'color:  #000000;'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: 'left',
                    width : 5,
                },
                updated_by_key: {
                    name: "updated_by_key",
                    label: "Updated by",
                    type: "Computed",
                    // filter: {type: 'input', match: 'contains'},
                    models: new UserModel(),
                    computed: (data) => {
                        data.updated_by_key ='' ;
                    },
                    class:"left",
                    width : 8,
                },
                updated_at : {
                    name: 'updated_at',
                    type: "Custom",
                    label: 'Updated date',
                    width: 10,
                    // filter: { type: 'DateRange', match: 'contains'},
                    class:"left",
                },
                detail_get: {
                    refs:  ' obj_vehicle_category { id name bond_fee }  user  { id fullname } ',
                    display: false
                },
                detail_get1: {
                    refs: 'id name duration unit_duration vehicle_category_id price_per_unit_before price_per_unit booking_fee effective_date created_at updated_at updated_by created_by active deleted ',
                    display: false
                },  
            })
    }

}